import { render, staticRenderFns } from "./WidgetForm.vue?vue&type=template&id=13fb7e00&scoped=true&"
import script from "./WidgetForm.vue?vue&type=script&lang=ts&"
export * from "./WidgetForm.vue?vue&type=script&lang=ts&"
import style0 from "./widgetForm.less?vue&type=style&index=0&id=13fb7e00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb7e00",
  null
  
)

export default component.exports